import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

// Swiper
import Swiper from 'swiper';
import { Autoplay, EffectFade, Pagination, Navigation, Controller } from 'swiper/modules';

// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsapVerticalLoop } from './gsapVerticalLoop';
import { gsapHorizontalLoop } from './gsapHorizontalLoop';

// Masonry
import Packery from 'packery';

// Components

// Global
window.Alpine = Alpine;

// Swiper
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/controller';

window.Swiper = Swiper;
Swiper.use([Autoplay, EffectFade, Pagination, Navigation, Controller]);

// GSAP
gsap.registerPlugin(ScrollTrigger);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.gsapVerticalLoop = gsapVerticalLoop;
window.gsapHorizontalLoop = gsapHorizontalLoop;

// Masonry
window.Packery = Packery;

// Inits
Alpine.plugin(collapse);
Alpine.start();